import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconLocationOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import {
  constants as gpsLocationConstants,
  GPSLocationModal,
} from '../../gpsLocation';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const SetGpsLocationButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);

  const showLanguageModal = () => {
    void dispatch(modalActions.showModal(gpsLocationConstants.GPS_LOCATION_MODAL_IDENTIFIER));

    trackEvent(TOOLBAR_TRACKING_NAMES.SET_LOCATION, { deviceType, testType });
  };

  return (
    <>
      <GPSLocationModal />

      <GenericButton
        dataQa="live-session-toolbar-set-gps-location-button"
        disabled={deviceToolsDisabled}
        icon={IconLocationOutline}
        label="Set GPS Location"
        onPress={showLanguageModal}
        role={role}
      />
    </>
  );
};

SetGpsLocationButton.displayName = 'SetGpsLocationButton';

export default SetGpsLocationButton;
